// src/lib/locationApi.ts
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY

// Même centre pour tous les calculs
export const CRISSIER = { lat: 46.5506, lng: 6.5756 }

const DEFAULT_HEADERS: HeadersInit = {
  'Content-Type': 'application/json',
  // On ajoute le header Authorization uniquement si la clé existe,
  // pour éviter l'erreur "Missing authorization header"
  ...(SUPABASE_ANON_KEY ? { Authorization: `Bearer ${SUPABASE_ANON_KEY}` } : {}),
}

// ---------- Types ----------
export type GeocodeResult = {
  lat: number
  lng: number
}

export type AutocompleteSuggestion = {
  display_name: string
  lat: string
  lng: string
}

// ---------- Géocodage via Edge Function ----------
export const geocodeAddress = async (address: string): Promise<GeocodeResult | null> => {
  if (!address.trim()) return null

  const response = await fetch(`${SUPABASE_URL}/functions/v1/geocode`, {
    method: 'POST',
    headers: DEFAULT_HEADERS,
    body: JSON.stringify({ address }),
  })

  if (!response.ok) {
    console.error('Erreur geocodeAddress:', await response.text())
    return null
  }

  const json = await response.json()

  if (!json.data || json.data.length === 0) return null

  return {
    lat: parseFloat(json.data[0].lat),
    lng: parseFloat(json.data[0].lon),
  }
}

// ---------- Autocomplétion via Edge Function ----------
export const fetchSuggestions = async (query: string): Promise<AutocompleteSuggestion[]> => {
  const trimmed = query.trim()
  if (trimmed.length < 3) return []

  const response = await fetch(`${SUPABASE_URL}/functions/v1/autocomplete`, {
    method: 'POST',
    headers: DEFAULT_HEADERS,
    body: JSON.stringify({ query: trimmed }),
  })

  if (!response.ok) {
    console.error('Erreur fetchSuggestions:', await response.text())
    return []
  }

  return await response.json()
}

// ---------- Distance via Haversine ----------
export const haversineDistance = (
  lat1: number,
  lon1: number,
  lat2: number,
  lon2: number
): number => {
  const R = 6371
  const dLat = ((lat2 - lat1) * Math.PI) / 180
  const dLon = ((lon2 - lon1) * Math.PI) / 180

  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos((lat1 * Math.PI) / 180) *
      Math.cos((lat2 * Math.PI) / 180) *
      Math.sin(dLon / 2) ** 2

  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
}
